module.exports = __webpack_public_path__ + "img/mastercard.4ebe3da8.png";